export const LICENSE_KEY = process.env.REACT_APP_MUI_KEY;
export const GOOGLE_MAP_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY;
export const X_API_KEY = process.env.REACT_APP_X_API_KEY_CLIENTES;
export const SERVICE_URL = process.env.REACT_APP_BASE_URL;
export const IR_URL = process.env.REACT_APP_IR_URL;
export const SSE_URL = process.env.REACT_APP_SSE_BASE_URL;